/** Public entries only: previews must not make disabled translations into ancestors. */
export const BREADCRUMB_ENTRIES_QUERY = `
query getBreadcrumbEntries($site: [String], $hubUris: [String]) {
  hubs: entries(site: $site, limit: null,
    uri: $hubUris) {
    url
    enabled
    enabledForSite
    status
    siteHandle
  }
  categories: entries(site: $site, limit: null, section: "blogCategories") {
    url
    enabled
    enabledForSite
    status
    siteHandle
  }
}
`
